import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalStepsList = ({ steps }) => {
  const getStepIcon = (order) => {
    const icons = ['CheckCircle', 'Shield', 'Award', 'Star'];
    return icons?.[order - 1] || 'Circle';
  };

  return (
    <div className="space-y-4">
      {steps?.map((step, index) => (
        <div key={step?.id} className="relative">
          {index < steps?.length - 1 && (
            <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-border" />
          )}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center relative z-10">
              <Icon name={getStepIcon(step?.stepOrder)} size={20} className="text-primary" />
            </div>
            <div className="flex-1 bg-card border border-border rounded-lg p-4">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-muted-foreground">
                      Step {step?.stepOrder}
                    </span>
                    {step?.isRequired && (
                      <span className="px-2 py-0.5 bg-error/10 text-error text-xs rounded">
                        Required
                      </span>
                    )}
                    {step?.canDelegate && (
                      <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded">
                        Can Delegate
                      </span>
                    )}
                  </div>
                  <h4 className="text-base font-semibold text-foreground mb-2">
                    {step?.stepName}
                  </h4>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-xs text-muted-foreground mb-1">Approver Role</p>
                      <p className="text-foreground font-medium">{step?.approverRole}</p>
                    </div>
                    {step?.approverEmail && (
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Approver Email</p>
                        <p className="text-foreground font-medium">{step?.approverEmail}</p>
                      </div>
                    )}
                    {step?.timeoutHours && (
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">Timeout</p>
                        <p className="text-foreground font-medium">{step?.timeoutHours} hours</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ApprovalStepsList;